module.exports = __webpack_public_path__ + "static/BT-desktop-18-b0b3554dfddf11b804fbf1ead69c5282.jpg";